<template>
  <MessageContainer
    :level="level"
  >
    <strong>
      {{ messageHeader }}
    </strong>{{ message }}
    <ExternalLink
      v-if="href"
      :href="href"
      :showExternalLinkIcon="false"
      :text="linkText"
    />
    <slot />
  </MessageContainer>
</template>

<script>
import Constants from 'client/util/Constants';
import ExternalLink from 'client/components/ExternalLink';
import MessageContainer from 'client/components/MessageContainer/MessageContainer';

const { info, error, warn } = Constants;

export default {
  name: 'ItemTableActionBarHeaderMessage',

  components: {
    MessageContainer,
    ExternalLink,
  },

  props: {
    href: {
      type: String,
      default: '',
    },
    level: {
      type: String,
      validator: value => [error, info, warn].includes(value),
      default: error,
    },
    linkText: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    messageHeader: {
      type: String,
      default: '',
    },
  },
};
</script>

<style>
</style>
